import React, { useState } from 'react'

import { BiHide, BiShow } from 'react-icons/bi'

import { useUser } from '../../../context'
import { ChallengeWithStatus } from '../../../types'
import {
  capitalizeFirstLetter,
  translateStatus,
} from '../../../utilFunctions/transformFunc'
import { ChallengeCardBtn } from '../../buttons'
import { ChallengeCard } from '../styles'

import {
  PreviewBadge,
  PreviewBadgesContainer,
  PreviewCard,
  PreviewHashtags,
  PreviewImage,
  PreviewMeta,
  PreviewTitle,
  TitleContainer,
} from './styles'

const ChallengeCards = ({ ch }: { ch: ChallengeWithStatus }) => {
  const { userRole } = useUser()
  const [instructions, setInstructions] = useState<boolean>(false)
  const badgeLabel = translateStatus(ch.status)

  const formatRange = () => {
    if (!ch.startDate && !ch.endDate) return ''
    const fmt = (d: string) => (d ? d.split('-').join('.') : '')
    return `${fmt(ch.startDate)}  –  ${fmt(ch.endDate)}`
  }

  return (
    <>
      <ChallengeCard>
        <PreviewCard>
          <PreviewImage
            src={ch.image || 'assets/profile.png'}
            alt={ch.altText}
            loading="lazy"
            decoding="async"
          />

          <PreviewBadgesContainer>
            {userRole === 'admin' && (
              <PreviewBadge
                $status={ch.status}
                $visibility={ch.visibility}
                className="visibility"
              >
                {ch.visibility ? <BiShow /> : <BiHide />}
                {capitalizeFirstLetter(ch.visibility ? 'Visible' : 'Oculto')}
              </PreviewBadge>
            )}
            <PreviewBadge
              $status={ch.status}
              $visibility={ch.visibility}
              className="status"
            >
              {badgeLabel}
            </PreviewBadge>
          </PreviewBadgesContainer>
          <TitleContainer>
            <div style={{ width: '100%' }}>
              <PreviewTitle>{ch.title || 'Título del desafío'}</PreviewTitle>
              <PreviewMeta>{formatRange()}</PreviewMeta>
            </div>
          </TitleContainer>

          <PreviewMeta>
            Descripción: <br />
            {ch.description}
          </PreviewMeta>
          <PreviewHashtags>
            hashtags: <br /> {ch.hashtags.map((tag) => `#${tag}`).join(' ')}
          </PreviewHashtags>
          {instructions && (
            <PreviewMeta>
              Instrucciones: <br />
              {ch.instructions}
            </PreviewMeta>
          )}
          <ChallengeCardBtn
            challenge={ch}
            onClickFn={() => setInstructions(!instructions)}
          />
        </PreviewCard>
      </ChallengeCard>
    </>
  )
}

export default ChallengeCards
